import styled from 'styled-components';

export default styled.div`
    display: flex;
    justify-content: center;

    font-family: 'Atlas Grotesk Regular', sans-serif;
    color: #143e44;
`;

export const NoFlexBody = styled.div`
    justify-content: center;

    font-family: 'Atlas Grotesk Regular', sans-serif;
    color: #143e44;
`;
